import { useQuery } from '@apollo/client';
import { enqueueSnackbar } from 'notistack';

import { gql } from '../../generated';

const GET_ALL_GEO_REGIONS = gql(/* GraphQL */ `
  query GetAllGeoRegions {
    country_region {
      id
    }
  }
`);

export const useGeoRegion = () => {
  const { loading, data } = useQuery(GET_ALL_GEO_REGIONS, {
    onError: (error) => {
      enqueueSnackbar(error.message, { variant: 'error' });
    },
  });

  return {
    loading,
    data,
  };
};
